import * as React from 'react';
import Toolbar from '@mui/material/Toolbar';

const EditToolbar = () => {
    return <Toolbar sx={{ display: 'none' }}></Toolbar>;
};

export default EditToolbar;
